import { useEffect, useState } from "react";
import {
FiMenu,
FiX,
FiPhone
} from "react-icons/fi";

import "./Navbar.css";


function Navbar(){

const [scrolled,setScrolled]=useState(false);

const [menuOpen,setMenuOpen]=useState(false);



useEffect(()=>{


const handleScroll=()=>{

setScrolled(window.scrollY > 40);

};


window.addEventListener(
"scroll",
handleScroll
);


return()=>{

window.removeEventListener(
"scroll",
handleScroll
);

};


},[]);



const closeMenu=()=>{

setMenuOpen(false);

};



return(

<header className={`navbar ${scrolled ? "scrolled":""}`}>



<div className="container navbar-container">



<a href="/" className="logo">

Nashie

<span>
Locksmiths
</span>

</a>





<nav className={`nav-links ${menuOpen?"open":""}`}>

<a href="#home" onClick={closeMenu}>
Home
</a>

<a href="#services" onClick={closeMenu}>
Services
</a>

<a href="#about" onClick={closeMenu}>
About
</a>

<a href="#contact" onClick={closeMenu}>
Contact
</a>


</nav>






<div className="nav-actions">


<a
href="tel:+27604971899"
className="call-button"
>

<FiPhone/>

<span>
Emergency Call
</span>

</a>



<button
className="menu-toggle"
onClick={()=>setMenuOpen(!menuOpen)}
>

{
menuOpen
?
<FiX/>
:
<FiMenu/>
}

</button>


</div>




</div>


</header>


)

}


export default Navbar;